import type { Filters } from "../types/reports";

// ── Query string serializer ──
// Pula null/undefined/""/"all" pra não poluir a URL.
export function qs(params: Record<string, unknown> | undefined): string {
    if (!params) return "";
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v === null || v === undefined || v === "" || v === "all") return;
        if (typeof v === "boolean") {
            sp.append(k, v ? "true" : "false");
            return;
        }
        sp.append(k, String(v));
    });
    const s = sp.toString();
    return s ? `?${s}` : "";
}

const todayISO = () => new Date().toISOString().slice(0, 10);
const yesterdayISO = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d.toISOString().slice(0, 10);
};

// Converte o store de filtros pros query params da API.
// Replica `filtersToParams` do protótipo (dash-api.jsx).
export function filtersToParams(filters: Filters): Record<string, string | undefined> {
    const base: Record<string, string | undefined> = {
        projectId: filters.project && filters.project !== "all" ? filters.project : undefined,
        categoryId: filters.category && filters.category !== "all" ? filters.category : undefined,
        compare: filters.compare ? "true" : undefined,
    };

    if (filters.period === "today") {
        const ymd = todayISO();
        return { preset: "today", from: ymd, to: ymd, ...base };
    }
    if (filters.period === "yesterday") {
        const ymd = yesterdayISO();
        return { preset: "yesterday", from: ymd, to: ymd, ...base };
    }
    return {
        preset: filters.period && filters.period !== "custom" ? filters.period : undefined,
        from: filters.from || undefined,
        to: filters.to || undefined,
        ...base,
    };
}

// Estável: usado como key do React Query (mesmo filtro = mesma key).
export function filterKey(filters: Filters): string {
    return JSON.stringify(filters);
}

// Label legível pro chip do filtro de período
export function getPeriodLabel(filters: Filters): string {
    if (filters.period === "custom" && filters.from && filters.to) {
        return `${filters.from} → ${filters.to}`;
    }
    const labels: Record<string, string> = {
        today: "Hoje",
        yesterday: "Ontem",
        "7d": "7 dias",
        "30d": "30 dias",
        "90d": "90 dias",
    };
    return labels[filters.period] || filters.period;
}
